/*!
 * Pro Tune — product page enhancements
 *
 * - Lê o preço da variante selecionada
 * - Aplica promoção específica por produto
 * - Aceita desconto em R$ ou %
 * - Exibe preço promocional + preço original riscado
 * - Exibe "R$ xxx OFF" abaixo
 * - Mantém o bloco promocional acima do box PIX/cartão
 * - Calcula PIX e parcelamento sobre o preço promocional
 */
(function () {
  'use strict';

  var MAX_PARCELAS = 10;
  var PARCELA_MIN  = 99;

  /*
   * PROMOÇÕES
   *
   * Exemplos:
   *
   * desconto em reais:
   * desconto: 'R$800'
   *
   * desconto percentual:
   * desconto: '15%'
   *
   * também aceita:
   * desconto: 800
   */
  var PROMOCOES = {
    'tdl-pro-tune-evo-street': {
      desconto: 'R$0'
    }
  };


  /* =========================================================
     UTILITÁRIOS
     ========================================================= */

  function safe(fn) {
    try {
      return fn();
    } catch (e) {
      return null;
    }
  }

  function formatBRL(value) {
    return 'R$ ' +
      value
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function round2(value) {
    return Math.round(value * 100) / 100;
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : '';
  }


  /* =========================================================
     PROMOÇÕES
     ========================================================= */

  function parsePromotionDiscount(raw) {
    if (raw == null) return null;

    if (
      typeof raw === 'number' &&
      !isNaN(raw) &&
      raw > 0
    ) {
      return {
        tipo: 'valor',
        valor: raw
      };
    }

    if (typeof raw !== 'string') {
      return null;
    }

    var txt = raw.trim();

    if (!txt) {
      return null;
    }

    /*
     * Percentual:
     * '15%'
     * '15,5%'
     */
    if (txt.indexOf('%') !== -1) {
      var percentual = parseFloat(
        txt
          .replace('%', '')
          .replace(/\s+/g, '')
          .replace(',', '.')
      );

      if (
        !isNaN(percentual) &&
        percentual > 0
      ) {
        return {
          tipo: 'percentual',
          valor: percentual
        };
      }
    }

    /*
     * Valor:
     * 'R$800'
     * 'R$ 800'
     * 'R$800,00'
     * '800'
     */
    var valorTexto = txt
      .replace(/R\$/i, '')
      .replace(/\s+/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var valor = parseFloat(valorTexto);

    if (
      !isNaN(valor) &&
      valor > 0
    ) {
      return {
        tipo: 'valor',
        valor: valor
      };
    }

    return null;
  }


  function getPromotion(price) {
    var handle = getProductHandle();
    var config = PROMOCOES[handle];

    if (!config || !config.desconto) {
      return {
        active: false,
        originalPrice: price,
        finalPrice: price,
        discountAmount: 0,
        discountType: null,
        discountValue: 0
      };
    }

    var parsed = parsePromotionDiscount(
      config.desconto
    );

    if (!parsed) {
      return {
        active: false,
        originalPrice: price,
        finalPrice: price,
        discountAmount: 0,
        discountType: null,
        discountValue: 0
      };
    }

    var discountAmount = 0;

    if (parsed.tipo === 'percentual') {
      discountAmount =
        price * (parsed.valor / 100);
    } else {
      discountAmount =
        parsed.valor;
    }

    discountAmount =
      round2(discountAmount);

    var finalPrice =
      round2(price - discountAmount);

    if (finalPrice < 0) {
      finalPrice = 0;
    }

    return {
      active: true,
      originalPrice: round2(price),
      finalPrice: finalPrice,
      discountAmount: discountAmount,
      discountType: parsed.tipo,
      discountValue: parsed.valor
    };
  }


  /* =========================================================
     PREÇO / VARIANTE
     ========================================================= */

  function buildVariantPriceMap() {
    var map = {};

    safe(function () {
      var variants =
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        window.ShopifyAnalytics.meta.product.variants;

      if (!variants) return;

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];

        map[String(v.id)] =
          v.price / 100;
      }
    });

    return map;
  }


  function getSelectedVariantId() {
    var select =
      document.querySelector(
        'variant-picker select.variant-option__select, ' +
        '.variant-picker select'
      );

    if (!select) {
      return null;
    }

    var option =
      select.options[select.selectedIndex];

    if (!option) {
      return null;
    }

    return (
      option.getAttribute('data-variant-id') ||
      String(option.value) ||
      null
    );
  }


  function getPriceForSelectedVariant() {
    var map =
      buildVariantPriceMap();

    var variantId =
      getSelectedVariantId();

    /*
     * 1. data-variant-id
     */
    if (
      variantId &&
      map[variantId]
    ) {
      return map[variantId];
    }

    /*
     * 2. input hidden do product form
     */
    safe(function () {
      var input =
        document.querySelector(
          'input[name="id"][ref="variantId"], ' +
          'form.shopify-product-form input[name="id"]'
        );

      if (
        input &&
        map[input.value]
      ) {
        variantId =
          input.value;
      }
    });

    if (
      variantId &&
      map[variantId]
    ) {
      return map[variantId];
    }

    /*
     * 3. JSON embutido no variant-picker
     */
    safe(function () {
      var jsonScript =
        document.querySelector(
          'variant-picker script[type="application/json"]'
        );

      if (!jsonScript) return;

      var data =
        JSON.parse(jsonScript.textContent);

      if (
        data &&
        data.price
      ) {
        variantId = '__json__';
        map['__json__'] =
          data.price / 100;
      }
    });

    if (
      variantId &&
      map[variantId]
    ) {
      return map[variantId];
    }

    return 0;
  }


  /* =========================================================
     BLOCO PIX / CARTÃO
     ========================================================= */

  function buildPaymentBlock() {
    var div =
      document.createElement('div');

    div.setAttribute(
      'data-pt-payment-block',
      ''
    );

    div.className =
      'protune-payment-block';

    div.innerHTML =
      '<div class="protune-payment-grid">' +

        '<div class="protune-payment-col protune-payment-col--pix">' +

          '<span class="protune-payment-badge protune-payment-badge--pix">' +
            '5% OFF NO PIX' +
          '</span>' +

          '<div class="protune-payment-method">' +

            '<svg class="protune-payment-pix-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +

              '<g fill="#00A859">' +

                '<path d="M48.18 43.42a8 8 0 0 1-5.69-2.36L34.32 32.9a1.55 1.55 0 0 0-2.14 0l-8.2 8.18a8 8 0 0 1-5.7 2.36h-1.6l10.36 10.36a8 8 0 0 0 11.32 0L48.74 43.42z"/>' +

                '<path d="M18.28 20.58a8 8 0 0 1 5.7 2.36l8.2 8.16a1.51 1.51 0 0 0 2.14 0l8.17-8.13A8 8 0 0 1 48.18 20.6h1l-10.39-10.4a8 8 0 0 0-11.32 0L17.16 20.58z"/>' +

                '<path d="M55.73 26.31 49.45 20a1.18 1.18 0 0 1-.45.09h-2.82a5.65 5.65 0 0 0-3.95 1.64L34 29.84a3.95 3.95 0 0 1-5.59 0l-8.2-8.16a5.65 5.65 0 0 0-4-1.64h-3.47A1.13 1.13 0 0 1 12.3 20l-6.28 6.28a8 8 0 0 0 0 11.31l6.28 6.28a1.13 1.13 0 0 1 .42-.08h3.47a5.65 5.65 0 0 0 4-1.64l8.2-8.18a4.08 4.08 0 0 1 5.6 0l8.17 8.16a5.65 5.65 0 0 0 4 1.64H49a1.18 1.18 0 0 1 .45.08l6.28-6.28a8 8 0 0 0 0-11.32z"/>' +

              '</g>' +

            '</svg>' +

            '<span>À vista no Pix</span>' +

          '</div>' +

          '<div class="protune-payment-value protune-payment-value--pix" data-pt-pix>—</div>' +

          '<div class="protune-payment-sub protune-payment-sub--green">' +
            '(5% de desconto)' +
          '</div>' +

        '</div>' +

        '<div class="protune-payment-col protune-payment-col--card">' +

          '<span class="protune-payment-badge protune-payment-badge--card">' +
            '10X SEM JUROS' +
          '</span>' +

          '<div class="protune-payment-method">' +

            '<svg class="protune-payment-card-icon" viewBox="0 0 24 24" fill="none" stroke="#F68712" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +

              '<rect x="2" y="5" width="20" height="14" rx="2"/>' +

              '<line x1="2" y1="10" x2="22" y2="10"/>' +

            '</svg>' +

            '<span>No cartão de crédito</span>' +

          '</div>' +

          '<div class="protune-payment-value protune-payment-value--card">' +
            '<span data-pt-installment>—</span>' +
          '</div>' +

          '<div class="protune-payment-sub">' +
            'Total: <span data-pt-total>—</span>' +
          '</div>' +

        '</div>' +

      '</div>';

    return div;
  }


  function setTextIfChanged(el, value) {
    if (
      el &&
      el.textContent !== value
    ) {
      el.textContent = value;
    }
  }


  function findInsertAnchor() {
    return document.querySelector(
      '.product-information product-price, ' +
      '.product-information [data-block-id*="product_price"]'
    );
  }


  /* =========================================================
     BLOCO PREÇO PROMOCIONAL
     ========================================================= */

  function renderPromotionalMainPrice(promotion) {
    var anchor =
      findInsertAnchor();

    if (!anchor) return;

    /*
     * Remove renderização anterior
     */
    var existing =
      document.querySelector(
        '[data-pt-promotional-price]'
      );

    if (existing) {
      existing.remove();
    }

    /*
     * Sem promoção:
     * mantém preço normal do Shopify
     */
    if (!promotion.active) {
      anchor.style.display = '';
      return;
    }

    /*
     * Esconde preço padrão do tema
     */
    anchor.style.display = 'none';

    var promoBlock =
      document.createElement('div');

    promoBlock.setAttribute(
      'data-pt-promotional-price',
      ''
    );

    promoBlock.className =
      'protune-promotional-price';

    /*
     * Resultado:
     *
     * R$ 2.500,00  R$ 3.300,00
     *               riscado
     *
     * R$ 800,00 OFF
     */
promoBlock.innerHTML =

  '<div class="protune-promotional-price__row">' +

    '<span class="protune-promotional-price__current">' +
      formatBRL(promotion.finalPrice) +
    '</span>' +

    '<span class="protune-promotional-price__original">' +
      formatBRL(promotion.originalPrice) +
    '</span>' +

    '<span class="protune-promotional-price__discount">' +
      '(' +
      formatBRL(promotion.discountAmount) +
      ' OFF)' +
    '</span>' +

  '</div>';

    anchor.parentNode.insertBefore(
      promoBlock,
      anchor.nextSibling
    );
  }


  /* =========================================================
     RENDER PRINCIPAL
     ========================================================= */

  function renderBlock(originalPrice) {
    if (
      !originalPrice ||
      originalPrice <= 0
    ) {
      return;
    }

    var promotion =
      getPromotion(originalPrice);

    var price =
      promotion.finalPrice;

    /*
     * Renderiza o preço promocional primeiro
     */
    renderPromotionalMainPrice(
      promotion
    );

    /*
     * PIX sobre preço final
     */
    var pix =
      round2(price * 0.95);

    /*
     * Parcelamento sobre preço final
     */
    var maxParcelas =
      Math.min(
        MAX_PARCELAS,
        Math.floor(
          price / PARCELA_MIN
        )
      );

    if (maxParcelas < 1) {
      maxParcelas = 1;
    }

    var block =
      document.querySelector(
        '[data-pt-payment-block]'
      );

    /*
     * Cria box PIX/cartão
     * sempre depois do preço promocional
     */
    if (!block) {

      block =
        buildPaymentBlock();

      var promoBlock =
        document.querySelector(
          '[data-pt-promotional-price]'
        );

      var anchor =
        findInsertAnchor();

      if (
        promoBlock &&
        promoBlock.parentNode
      ) {

        promoBlock.parentNode.insertBefore(
          block,
          promoBlock.nextSibling
        );

      } else if (
        anchor &&
        anchor.parentNode
      ) {

        anchor.parentNode.insertBefore(
          block,
          anchor.nextSibling
        );

      } else {

        return;
      }
    }

    /*
     * Garante ordem correta após updates do Horizon
     */
    var promoBlockAtual =
      document.querySelector(
        '[data-pt-promotional-price]'
      );

    if (
      promoBlockAtual &&
      block &&
      promoBlockAtual.parentNode === block.parentNode &&
      promoBlockAtual.nextSibling !== block
    ) {

      promoBlockAtual.parentNode.insertBefore(
        block,
        promoBlockAtual.nextSibling
      );
    }

    var badge =
      block.querySelector(
        '.protune-payment-badge--card'
      );

    if (badge) {
      badge.textContent =
        maxParcelas > 1
          ? (
              maxParcelas +
              'X SEM JUROS'
            )
          : 'À VISTA CARTÃO';
    }

    setTextIfChanged(
      block.querySelector(
        '[data-pt-pix]'
      ),
      formatBRL(pix)
    );

    setTextIfChanged(
      block.querySelector(
        '[data-pt-installment]'
      ),

      maxParcelas > 1
        ? (
            maxParcelas +
            'x ' +
            formatBRL(
              price / maxParcelas
            )
          )
        : formatBRL(price)
    );

    setTextIfChanged(
      block.querySelector(
        '[data-pt-total]'
      ),
      formatBRL(price)
    );
  }


  function calculateAndRender() {
    safe(function () {

      var price =
        getPriceForSelectedVariant();

      renderBlock(price);

    });
  }


  /* =========================================================
     INICIALIZAÇÃO
     ========================================================= */

  function init() {

    var attempts = 0;

    function tick() {

      attempts++;

      calculateAndRender();

      if (
        !document.querySelector(
          '[data-pt-payment-block]'
        ) &&
        attempts < 20
      ) {

        setTimeout(
          tick,
          250
        );
      }
    }

    tick();

    safe(function () {

      /*
       * Mudança de variante
       */
      document.addEventListener(
        'change',

        function (e) {

          var target =
            e.target;

          if (!target) return;

          if (
            target.matches(
              'variant-picker select, ' +
              '.variant-picker select, ' +
              '.variant-option__select'
            ) ||

            (
              target.tagName === 'SELECT' &&
              target.closest(
                'variant-picker'
              )
            )
          ) {

            setTimeout(
              calculateAndRender,
              50
            );

            setTimeout(
              calculateAndRender,
              300
            );
          }
        },

        true
      );

      /*
       * Evento variant:update do Horizon
       */
      document.addEventListener(
        'variant:update',

        function (e) {

          safe(function () {

            if (
              e.detail &&
              e.detail.resource &&
              e.detail.resource.price != null
            ) {

              renderBlock(
                e.detail.resource.price / 100
              );

              return;
            }

            setTimeout(
              calculateAndRender,
              100
            );

            setTimeout(
              calculateAndRender,
              400
            );

          });

        }
      );

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  document.addEventListener(
    'shopify:section:load',

    function () {

      setTimeout(
        calculateAndRender,
        150
      );

    }
  );

})();